import React from "react";
import { Link } from "react-router-dom"; // Use Link from react-router-dom

import "./style.css";
import logo from "../../assets/jeantnl-logo.png";

import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<div className="footer-grid">
					{/* Column 1: Brand */}
					<div className="footer-brand">
						<div className="brand-header">
							{/* <div className="brand-logo">JT</div> */}
							<img src={logo} alt="Jean Tax & Legal Logo" className="logo-icon" />
							<div>
								<div className="brand-name">Jean Tax & Legal</div>
								<div className="brand-sub">Practitioners</div>
							</div>
						</div>
						<p className="brand-text">
							Precision. Integrity. Compliance you can trust.
						</p>
					</div>

					{/* Column 2: Quick Links */}
					<div className="footer-links">
						<h3>Quick Links</h3>
						<ul>
							<li><Link to="/">Home</Link></li>
							<li><Link to="/about">About Us</Link></li>
							<li><Link to="/services">Services</Link></li>
							<li><Link to="/areas-of-practice">Areas of Practice</Link></li>
							<li><Link to="/contact">Contact</Link></li>
						</ul>
					</div>

					{/* Column 3: Services (These are non-navigable list items) */}
					<div className="footer-services">
						<h3>Our Services</h3>
						<ul>
							<li>Taxation</li>
							<li>Legal Advisory</li>
							{/* <li>VAT & SARS eFiling</li> */}
							<li>Deceased Estates Administration</li>
							<li>Secretarial Services</li>
						</ul>
					</div>

					{/* Column 4: Contact Info */}
					<div className="footer-contact">
						<h3>Contact Us</h3>
						<ul>
							<li>
								{/* Email Link */}
								<span className="icon-placeholder">✉</span>
								<a href="mailto:info@jeantaxandlegal.co.za">info@jeantaxandlegal.co.za</a>
							</li>
							<li>
								{/* Phone Number (span as it's not a link) */}
								<span className="icon-placeholder">📞</span>
								<span>+27 82 676 9842</span>
							</li>
							{/* <li>
								// {/* Phone Number (span as it's not a link)
								<span className="icon-placeholder">📞</span>
								<span>+27 67 621 8734</span>
							</li> */}
							<li>
								{/* Operating Hours (span as it's not a link) */}
								<span className="icon-placeholder">⏱</span>
								<span>Mon–Fri, 8:00–17:00</span>
							</li>
						</ul>
						<div className="footer-social">
							{/* Social Media Links - REPLACE # with actual URLs */}
							<a href="https://www.linkedin.com/company/jean-tax-and-legal-practitioners/" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><FaLinkedin size={20} className="social-icon" /></a>
							{/* <a href="https://facebook.com/yourpage" aria-label="Facebook">Ⓕ</a>
							<a href="https://instagram.com/yourpage" aria-label="Instagram">Ⓞ</a> */}
						</div>
					</div>
				</div>

				<div className="footer-bottom">
					<p>© {new Date().getFullYear()} Jean Tax & Legal Practitioners. All rights reserved.</p>
					<p>© {new Date().getFullYear()} Powered by <a href="https://mftechs.co.za/">Moonface Techs</a></p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;